import React from "react"

const OnBoardingContainer = ({ ComponentFirst, ComponentSecond }) => {
  return (
    <div className="w-[100%] bg-white p-[80px] h-full">
      <div className="grid grid-cols-5 gap-[70px] h-full">
        <div className="col-span-2 flex flex-col justify-between">{ComponentFirst}</div>
        <div className="col-span-3">{ComponentSecond}</div>
      </div>
    </div>
  )
}

export default OnBoardingContainer
